import AdditionalListIcon from '@components/icons/AdditionalListIcon';
import ListIcon from '@components/icons/ListIcon';
import PlanetIcon from '@components/icons/PlanetIcon';
import ShieldIcon from '@components/icons/ShieldIcon';
import StarIcon from '@components/icons/StarIcon';
import TargetIcon from '@components/icons/TargetIcon';
import WalletIcon from '@components/icons/WalletIcon';

export function getDocumentIcon(code: string) {
  let icon: () => React.JSX.Element | null = null;

  switch (code) {
    case 'constituent':
      icon = StarIcon;
      break;
    case 'contracts':
      icon = ListIcon;
      break;
    case 'appendices':
      icon = AdditionalListIcon;
      break;
    case 'calculations':
      icon = WalletIcon;
      break;
    case 'closing_documents':
      icon = ShieldIcon;
      break;
    case 'customs_documents':
      icon = TargetIcon;
      break;
    case 'other_documents':
      icon = ListIcon;
      break;
    case 'payment_documents':
      icon = WalletIcon;
      break;
    case 'permit_documentation':
      icon = ShieldIcon;
      break;
    case 'shipping_documents':
      icon = StarIcon;
      break;
    case 'transportation_documents':
      icon = PlanetIcon;
      break;
    default:
      icon = ListIcon;
  }

  return icon;
}
